import React, {useMemo, useState} from 'react';
import {useTranslation, Trans} from "react-i18next";
import Currency from "../../Utils/Number/Currency";
import BasicDataTable from "../../Utils/BasicDataTable";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const PopupAdjustment = (props) => {

	const {t, i18n} = useTranslation();
	const [selectedAmount,setSelectedAmount] = useState(props.amount)
    let amountPossibility = props.amountPossibility;
    let amount = props.amount;

    let handleCloseModal = props.handleCloseModal;
    let message = <React.Fragment>
        <p><strong>{t('popup_adjustment.content.title')}</strong></p>

		{
			props.getSelectedInvoices(selectedAmount).map((invoice) => {
				if (invoice.paidAmount === invoice.balanceAmount.value) {
					return <p><Trans
						i18nKey="popup_adjustment.content.total_payment"
						components={{
							balance: <Currency value={invoice.balanceAmount.value} />
						}}
					/></p>
				}
				else{
					return <p><Trans
						i18nKey="popup_adjustment.content.partial_payment"
						components={{
							balance: <Currency value={invoice.balanceAmount.value} />,
							paidAmount: <Currency value={invoice.paidAmount} />
						}}
					/></p>
				}

			})
		}
    </React.Fragment>;

    if(amount === props.limitTester.max || props.cleanedPossibilityCustom || props.isCustomRange){
        message = <React.Fragment>
            <strong>{t('payment.popup.warningmaxtexttitle', {amount: amount.toFixed(2)})}</strong>
            <p>{t('payment.popup.warningmaxtextcontent')}</p>
        </React.Fragment>
    }


	const generateTable = (invoices, insub) => {

		const columns = useMemo(
			() => [
				{
					Header: t("docs.invoices.table.headers.invoice_no"),
					accessor: "invoiceNumber",
					Cell: (props) => {
						if (props.value) return props.value;
						else return "";
					},
				},
				{
					Header: t("docs.invoices.table.headers.amount"),
					accessor: "balanceAmount",
					Cell: (props) => {
						return <React.Fragment>
								<span className="amount-price">
									{props.value ? <Currency value={props.value.value}/> : ""}
								</span>
							<strong className="span--c-red">
								<Currency value={-(props.row.original.paidAmount)}/>
							</strong><br/>
						</React.Fragment>
					},
				},
				{
					Header: t('docs.invoices.table.headers.balance'),
					accessor: "balanceAmount.value",
					show: false,
					Cell: (props) => {
						return (
							<span className="amount-price">
								{props.value ? <Currency value={props.value-props.row.original.paidAmount}/> : ""}
							</span>)
					},
				}
			],
			[t, i18n, invoices]
		);

		return <div id="table-payment-resume">
			<BasicDataTable columns={columns} data={invoices} classes={'test'}/>
		</div>
	}


    return (
        <React.Fragment>
            <div className="popup-adjustement-messages">{message}</div>
            <strong>{t('payment.popup.pleasemakechoice')}</strong>
            <div className="choices">
                <ul>
                    {amountPossibility.sort((a1, a2) => {
						return parseFloat(a1.amount) - parseFloat(a2.amount)
					}).map((i, index) => {
						let inputPrefix = '', toolipPrefix = '';
						if (i.type === 'partial') {
							inputPrefix = t('popup_adjustment.choices.choice_one.title')
							toolipPrefix = t('popup_adjustment.choices.choice_one.tooltip')
						} else if (index === amountPossibility.length - 1) {
							inputPrefix = t('popup_adjustment.choices.choice_two.title')
							toolipPrefix = t('popup_adjustment.choices.choice_two.tooltip')
						} else {
							inputPrefix = t('popup_adjustment.choices.choice_three.title')
							toolipPrefix = t('popup_adjustment.choices.choice_three.tooltip')
						}

                        return <>
						<li key={index}>
							<div className="choices__heading">
								<strong>{inputPrefix}</strong>
								<OverlayTrigger placement='top'
												overlay={<Tooltip id="tooltip-right" >
													{toolipPrefix}
												</Tooltip>}>
									<div className="btn-info-tooltip btn-info-tooltip--inline"><i
										className="far fa-info-circle"></i></div>
								</OverlayTrigger>
							</div>

							<div className="choices__content">
								<input type="radio" name="amount_possibility" id={`amount_possibility_${index}`}
									   checked={selectedAmount==i.amount}
									   value={i.amount} onChange={(event) => {
									setSelectedAmount(i.amount)

									document.getElementById("inputfixamount").value = event.target.value;
									props.handleFixAmount(parseFloat(event.target.value).toFixed(2));
								}
								}
								/>
								<label htmlFor={`amount_possibility_${index}`}><Currency value={i.amount}/></label>
							</div>

                        </li>
						<div className="choices__separator"></div>
						</>
                    })}
                </ul>
            </div>
			<div className="row">
				<div className="col-sm-12">
					<strong
						className="d-block mb-2">{t(`payment.popup.resume.default`)} {props.theSelection ? `(${props.theSelection.length})` : ''}</strong>
					{props.getSelectedInvoices(selectedAmount) && <React.Fragment>
						{generateTable(props.getSelectedInvoices(selectedAmount), false)}
					</React.Fragment>}
				</div>
			</div>
			<div
				className="modal-footer justify-content-between">
				<button onClick={
					() => {
						document.getElementById("inputfixamount").value = props.amount;
						props.handleFixAmount(parseFloat(props.amount).toFixed(2));
						handleCloseModal();
					}}
						className="btn btn--outline btn--outline--black btn--fs-12"
						style={{minWidth: "160px"}}>{t("payment.btn.close")}&nbsp;&nbsp;
                </button>
                <button onClick={
                    () => {
                        handleCloseModal();
                        props.validationSecondStepFixedPayment(selectedAmount);
                    }}
                        className="btn btn--raised btn--raised--red btn--fs-12"
                        style={{minWidth: "160px"}}>{t("payment.btn.continue_select")}&nbsp;&nbsp;
                </button>
            </div>
        </React.Fragment>
    )
}

export default PopupAdjustment;
